module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/V5Lh8Y/tc-custom/9798886936544.jpg?1705056297978",
      "alt": "This image is the cover for the book Do No Harm"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Do No Harm\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_vm._v("Doctor Gideon Teague is ready to call it quits as he nears the end of his medical training. Years of continuous hard work and the specter of tragedy following him from his time as a Marine have taken a heavy toll and his physical and emotional reserves are spent. In the nick of time, an opportunity for a mission trip to Honduras seems like just the ticket to rekindle a long dead spark of passion and adventure; and to escape the day-to-day drudgery of his life as a resident physician.  While there, he and a pragmatic service missionary named Eliza are violently sucked into the vast criminal underworld infecting the region. To save themselves from being trafficked, Gideon will have to embrace the military experience he’d forsaken and confront the ghosts that drove him away. Will it be enough, or will he lose what little of his self-identity remains?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tom B. Stone\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0mm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Tom B. Stone grew up in a funeral home in the Mountain West. After spending 2 years abroad in Argentina, he decided the funeral business wasn’t for him and chose a career in medicine instead. Now he has the honor to care for some of our nation’s veterans who continue to serve him as educators and inspiration for his stories. He currently lives in the Midwest with his wife, 5 children, and 10,000 honeybees.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0